

































import { Vue, Component, Watch } from 'vue-property-decorator';
import renderMarkdown from '../markdown/markdown';
import PageTitle from '@/components/PageTitle.vue';
import HTTP, { handleAPIError } from '@/api';
import { codemirror } from 'vue-codemirror';
import 'codemirror/keymap/sublime';

@Component({
  components: {
    PageTitle,
    codemirror,
  },
})
export default class Home extends Vue {
  public markdown = '';
  public pageName = '';
  public dirty = false;
  public interval: number | null = null;

  get html() {
    return renderMarkdown(this.markdown, this.pageName);
  }

  public mounted() {
    window.setInterval(async () => {
      await this.save();
    }, 2000);

    document.querySelector('.html')!.addEventListener('click', event => {
      const target = event.target! as HTMLElement;
      if (target && target.classList.contains('wiki-page-link')) {
        const page = target.dataset.wikiPage;
        if (page) {
          this.$router.push({ name: 'page', params: { page } });
        }
      }
    });

    this.init(this.$route.params.page);
  }

  public async beforeRouteUpdate(to: any, from: any, next: any) {
    await this.save();
    this.init(to.params.page);
    next();
  }

  public async beforeRouteLeave(to: any, from: any, next: any) {
    await this.save();
    next();
  }

  public async init(pageName: string) {
    let response = null;
    try {
      response = await HTTP.get(`/pages/${pageName}/`);
    } catch (e) {
      handleAPIError(e);
      return;
    }
    this.pageName = pageName;
    if (response.data.text === null) {
      this.markdown = '';
    } else {
      this.markdown = response.data.text;
    }
    document.getElementsByTagName(
      'title'
    )[0].innerHTML = `${pageName} - stormnotes.io`;
  }

  public async save() {
    if (this.dirty) {
      await HTTP.post(`/pages/${this.pageName}/`, {
        text: this.markdown,
      });
      this.dirty = false;
    }
  }

  @Watch('markdown')
  public onMarkdownChange() {
    this.dirty = true;
  }

  get codeMirrorOptions() {
    return {
      tabSize: 2,
      lineWrapping: true,
      keyMap: 'sublime',
      extraKeys: {
        Tab: 'indentMore',
      },
    };
  }

  public async upload(data: any) {
    const formData = new FormData();
    const imagefile = document.querySelector('#file');
    formData.append('file', data.file);
    return HTTP.post('/upload/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  public uploadSuccess(response: any) {
    const doc = (this.$refs.editor as any).codemirror.getDoc();
    const cursor = doc.getCursor();
    doc.replaceRange(`![](${response.data.url})`, cursor);
  }
}
